var exports = {
  "container": "xcc377c0b--c86197--container",
  "price-diff": "xcc377c0b--c86197--price-diff",
  "price-diff--red": "xcc377c0b--c86197--price-diff--red",
  "price-diff--green": "xcc377c0b--c86197--price-diff--green",
};

module.exports = exports;
